var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedCloseX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49.794,
    rx: 4.5,
    fill: "#DB4957",
    fillOpacity: 0.2,
    stroke: "#DB4957"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.13 19.131a.876.876 0 011.24 0L25 23.763l4.63-4.632a.875.875 0 111.24 1.24L26.237 25l4.633 4.63a.874.874 0 01-.285 1.429.877.877 0 01-.954-.19L25 26.238 20.37 30.87a.877.877 0 01-1.24-1.239l4.633-4.63-4.632-4.63a.874.874 0 010-1.24z",
    fill: "#DB4957"
  })));
}
export default SvgLedCloseX;